let language = {
    PRICE_LIST_TITLE: "分层价格表",
    PRICE_LIST_LINK:"FlexiBulk储蓄计划",
    PRICE_LIST_QTY_TEXT: "数量",
    PRICE_LIST_US_COUNTRY_TEXT: "美国",
    PRICE_LIST_OTHER_AREA_TEXT: "其他地区",
    PRICE_LIST_PRICE_TEXT: "价格"
};

export { language }
